module.exports = __webpack_public_path__ + "img/img6.9f093db5.png";